module.exports = __webpack_public_path__ + "static/img/connectb.08269dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/connectb.jpg
// module id = oJuS
// module chunks = 1